module.exports = __webpack_public_path__ + "media/common/images/personal-questionnaire-icon-64968e573ec2e47848c5829204e6310d.svg";